// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-457edafc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-tcfe-app/src/css"],"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modal.vue
// module id = 804
// module chunks = 0